import { BarChart } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

export const AchievementsSection = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.achievements.title" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/achievements/report">
          <List.ItemIcon>
            <BarChart />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.dashboard.achievements.report" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </StyledPaper>
  );
};
